import { IRewardState, LotteryRewardTypes } from 'src/types';

export const getRubiesCardData = (
    translate: (key: string, params?: Record<string, string | number>, fallback?: string) => string,
    rubiesAmount: number
): IRewardState => {
    return {
        id: 'rubies_special',
        lottery_reward_type: LotteryRewardTypes.RUBIES_SPECIAL,
        mission_id: '',
        collection_id: -1,
        rolled: true,
        date: 2,
        renderParams: {
            name: translate('quest.rubies.title', { count: rubiesAmount }),
            img: 'https://st.okcdn.ru/static/ny2025-assets/0-0-1/quest-list-rubin.png',
            congrats: '',
            background: 'linear-gradient(90deg, rgba(131, 102, 86, 0.12) 0%, rgba(255, 46, 0, 0.12) 100%)',
            desc: translate('quest.rubies.desc'),
            activateLink: 'https://ok.ru/app/okshop?entrypoint=tab://shop&st.refplace=39&refplace=39'
        }
    };
};
